export const sitesChannelHc = {
  paginasWeb: {
    pageTitle: "Site",
    introCreated: "Seu site já está criado. Entre e edite quando quiser.",
    introEmpty:
      "Crie o site da sua acomodação, com o seu calendário embutido. Você edita arrastando, sem escrever código.",
    emptyTitle: "Você ainda não tem site",
    emptyBody:
      "Você escolhe um modelo do setor, troca as fotos e os textos, e já tem um site publicável. O buscador de datas fica conectado ao seu calendário.",
    creating: "Criando…",
    createCta: "Criar meu site",
    createAnother: "Criar outro site",
    collapse: "Recolher",
    expand: "Ver detalhes",
    limitReached: "O teu plano permite {n} site(s).",
    lockedTitle: "Seu site vem com o plano Suite",
    lockedBody:
      "Para criar e gerenciar o site da sua hospedagem com a WACheckin, você precisa ter o plano Suite ativo.",
    lockedCta: "Ver o plano Suite",
    nameLabel: "Nome do seu site",
    viewWeb: "Ver o site",
    opening: "Abrindo…",
    editCta: "Editar minha página",
    noPublicAddress: "Ainda não tem endereço público",
    published: "Publicado",
    unpublished: "Não publicado",
    visibleToPublic: "Visível para o público",
    addressTitle: "Endereço do seu site",
    addressSubtitle:
      "Escolha em qual endereço você quer que seus hóspedes o vejam.",
    modeWacheckin: "Use um endereço da WACheckin",
    modeWacheckinHint: "Grátis e pronto na hora",
    modeOwn: "Use seu próprio domínio",
    modeOwnHint: "Se você já tiver um contratado",
    subdomainLabel: "A palavra que vai na frente",
    subdomainPlaceholder: "nome-da-sua-acomodacao",
    saving: "Salvando…",
    save: "Salvar",
    subdomainPreview: "Seu site ficará em",
    subdomainFree:
      "Escreva do jeito que quiser: nós transformamos em um endereço válido.",
    otherDomainNote:
      "Você também tem {dominio} conectado. Este endereço continuará funcionando e levará ao mesmo site.",
    noDomainYet: "Você ainda não disse qual domínio quer",
    continueConnection: "Continuar a conexão",
    connectDomain: "Conectar meu domínio",
    searchTitle: "Quais acomodações o buscador pode consultar",
    searchSubtitle:
      "As que você marcar aqui são as que seus hóspedes verão ao buscar datas.",
    missingPhotosLabel: "Ainda sem fotos:",
    missingPhotosHelp:
      "Envie-as em Reservas diretas → Imagens e elas aparecerão aqui. Não precisam estar à venda.",
    previewError: "Não foi possível carregar a pré-visualização.",
    previewRetry: "Tentar de novo",
    deleteExplain: "Apaga o site e tudo o que tem dentro. Não se pode desfazer.",
    deleteTitle: "Eliminar «{nombre}»?",
    deleteBody: "Isto não se pode desfazer. Se só queres escondê-lo, desliga «Visível para o público» e o site fica guardado.",
    deleteItemPages: "As suas {n} páginas, com textos e design",
    deleteItemAddress: "O endereço onde se vê agora",
    deleteItemMessages: "As mensagens que chegaram pelos seus formulários",
    deleteCancel: "Cancelar",
    deleteConfirm: "Sim, eliminar",
    deleting: "A eliminar…",
    previewTitle: "O teu site agora",
    previewDesktop: "Computador",
    previewMobile: "Telemóvel",
    previewLoading: "A carregar o teu site…",
    previewNote: "É assim que fica com as últimas alterações guardadas. Os teus hóspedes veem a última versão publicada.",
    footerNote:
      "Por enquanto cada conta tem um site. Escreva para nós se precisar de mais.",
    deleteWeb: "Excluir este site",
    mensajes: {
      title: "Mensagens do seu site",
      subtitle: "O que lhe escrevem nos formulários do seu site. Cada mensagem também lhe chega por e-mail.",
      inbox: "Caixa de entrada",
      archived: "Arquivadas",
      unread: "{n} por ler",
      empty: "Ainda ninguém lhe escreveu. Quando alguém preencher um formulário do seu site, vai vê-lo aqui e recebê-lo por e-mail.",
      emptyArchived: "Não tem mensagens arquivadas.",
      loadError: "Não foi possível carregar as mensagens.",
      retry: "Tentar de novo",
      reply: "Responder por e-mail",
      whatsapp: "WhatsApp",
      call: "Ligar",
      markRead: "Marcar como lida",
      markUnread: "Marcar como não lida",
      archive: "Arquivar",
      unarchive: "Voltar à caixa de entrada",
      delete: "Excluir",
      confirmDelete: "Excluir esta mensagem? Não é possível desfazer.",
      confirmYes: "Sim, excluir",
      confirmNo: "Não",
      form: "Formulário",
      from: "A partir de",
      more: "Ver mais",
      anonymous: "Sem nome",
      replySubject: "A sua mensagem em {sitio}",
      notSent: "O aviso por e-mail ainda não saiu.",
      errorAction: "Não foi possível guardar a alteração. Tente de novo.",
    },
    loadingAccommodations: "Carregando suas acomodações…",
    noPhotosYet:
      "Nenhuma das suas acomodações tem fotos ainda. Envie-as em Reservas diretas → Imagens e você poderá exibi-las aqui.",
    noAccommodations: "Você ainda não tem acomodações criadas.",
    loadError: "Não foi possível carregar suas páginas.",
    defaultSiteName: "Minha acomodação",
    createError: "Não foi possível criar a página.",
    saveError: "Não foi possível salvar.",
    subdomainTooLong: "Ficou longo demais.",
    subdomainReserved: "Essa palavra está reservada. Tente outra.",
    addressSaved: "Endereço salvo.",
    subdomainChecking: "Verificando se está livre…",
    subdomainAvailable: "Está livre. Seu site ficará em",
    subdomainChangeWarning: "Ao salvar, o endereço atual deixará de abrir.",
    subdomainTaken: "Outro site já usa esse endereço.",
    subdomainTryThis: "Este está livre:",
    subdomainUse: "Usar este",
    subdomainGeneric: "Não diz nada sobre sua acomodação. Sugerimos:",
    subdomainProposal: "Sugerimos um com o nome da sua acomodação:",
    domainHelpEmpty:
      "Nós guiamos você passo a passo: você digita o domínio, copia duas linhas no painel onde o comprou e nós verificamos.",
    domainHelpPending:
      "Faltam os registros no painel do seu domínio, ou eles ainda não chegaram a todos os lugares. Entre e nós verificamos.",
    popupBlocked: "Permita as janelas pop-up para abrir o editor.",
    editorError: "Não foi possível abrir o editor.",
    confirmDelete: `Excluir "{nombre}"? O site deixará de aparecer.`,
    deleteError: "Não foi possível excluir.",
  },

  selectOta: {
    lockBadge: "Recurso de assinatura",
    lockTitle: "Conecte suas OTAs com um plano ativo",
    lockText:
      "Para sincronizar <b>Booking, Airbnb, Vrbo, Expedia</b> e mais canais com o WA&nbsp;Checkin você precisa estar assinante de um plano. Com a sua assinatura, a Janet sincroniza preços, disponibilidade e reservas automaticamente — sem overbooking e sem tarefas manuais.",
    morePreviewTitle: "e mais de 100 OTAs",
    otasAvailable: "OTAs disponíveis",
    lockCta: "Ver planos e assinar",
    lockFoot:
      "Sincronização automática · Anti-overbooking · Suporte de conexão incluído",
    connectOtaTitle: "Conectar OTA",
    googleFaltan: "Falta 1 coisa na sua ficha para o Google | Faltam {count} coisas na sua ficha para o Google",
    googlePreparar: "Preparar",
    beta: "Beta",
    pctChipTitle: "Percentual de tarifa derivada para esta OTA",
    comingSoon: "Em breve",
    manage: "Gerenciar",
    connectNow: "Conectar agora",
    pctModalTitle: "Percentual de tarifa",
    pctModalHint:
      "Que percentual a mais (ou a menos) você vai cobrar dos seus hóspedes se eles reservarem pela <b>{ota}</b>? Use <b>+</b> para cobrar mais ou <b>−</b> para cobrar menos (ex.: <b>15.5</b> ou <b>−10</b>).",
    thisOta: "esta OTA",
    cancel: "Cancelar",
    saving: "Salvando…",
    save: "Salvar",
    exploreMore: "Explore mais de 100 OTAs disponíveis",
    activeConnections: "Conexões Ativas",
    searchPlaceholder: "Buscar...",
    loadingConnections: "Carregando conexões...",
    thChannel: "CANAL",
    thConnectionId: "ID DA CONEXÃO",
    thLastSync: "ÚLTIMA SINCRONIZAÇÃO",
    thActions: "AÇÕES",
    copied: "Copiado!",
    copyId: "Copiar ID",
    contactTitle: "Conecte-se com {name}",
    contactDescription:
      "Conecte facilmente sua conta {name} à nossa plataforma para agilizar sua experiência. Siga os passos abaixo para concluir o processo.",
    step1Title: "Crie uma conta {name}",
    step1Description:
      "Se você ainda não tem uma conta {name}, primeiro precisará criar uma.",
    createAccountLink: "Criar conta →",
    step1Hint: "Já tem uma conta? Vá para o passo 2.",
    step2Title: "Entrar em contato com a equipe de suporte",
    step2Description:
      "Assim que sua conta {name} estiver pronta, nossa equipe ajudará você a conectá-la.",
    contactSupportLink: "Entrar em contato com a equipe de suporte →",
    connectDirectNoSupport: "Conectar diretamente (sem suporte) →",
    step2Hint: "Recomendado apenas se você sabe o que vai configurar no Channex.",
    connectDirectly: "Conectar diretamente",
    iframeTitle: "Conectar com {channel}",
    iframeSubtitle: "Conexão segura gerenciada pelo channel manager",
    close: "Fechar",
    iframeLoading: "Abrindo a conexão segura…",
    actionRequired: "Ação necessária",
    viewPlans: "Ver planos",
    descBooking: "Alcance viajantes de negócios e de lazer no mundo todo",
    descAirbnb: "Conecte sua propriedade com milhões de viajantes no Airbnb",
    descVrbo: "Especializado em aluguéis de temporada para famílias",
    descExpedia: "Rede global de viagens com milhões de usuários ativos",
    descBnb: "Portal italiano de B&B e acomodações charmosas",
    descGvr: "Apareça de graça nos resultados do Google Maps e nas buscas",
    descAgoda: "Alcance viajantes da Ásia e do resto do mundo",
    descHotelbeds: "Camas para agências e operadores turísticos de todo o mundo",
    savePercentError: "Não foi possível salvar o percentual. Tente novamente.",
    channelGeneric: "Canal",
    statusInactive: "Inativo",
    statusConnected: "Conectado",
    statusSyncing: "Sincronizando",
    webReservationsName: "Reservas diretas pela web",
  },

  connectionChannel: {
    errorTitle: "Erro",
    successTitle: "Sucesso",
    connectionDisabled: "A conexão está desativada",
    syncError: "Erro ao sincronizar",
    loadPropertiesError: "Erro ao carregar propriedades",
    connectionUpdated: "Conexão atualizada {channelName}",
    updateConnError: "Erro ao atualizar a conexão: {detail}",
    unknownError: "Erro desconhecido",
    connectionWith: "Conexão com {channelName} {status}",
    stateUpdatedTitle: "Estado atualizado",
    confirmDeleteMessage:
      "Tem certeza de que deseja excluir esta conexão? Isso também excluirá as propriedades e reservas associadas.",
    confirmDeleteHeader: "Confirmar exclusão",
    deleteConnection: "Excluir conexão",
    no: "Não",
    connectionDeleted: "Conexão excluída com sucesso",
    deleteConnError: "Erro ao excluir a conexão: {detail}",
    webhookCopied: "Webhook copiado para a área de transferência",
    webhookCopyError: "Erro ao copiar o webhook",
    title: "Canal de conexão (PMS)",
    description:
      "Nesta seção você poderá conectar com sistemas de gestão de propriedades (PMS) para realizar consultas, gestão e atualização de informações de forma eficiente e sem erros.",
    connectedAccount: "Conta conectada",
    switchTooltip:
      "Parar ou ativar o serviço que recebe as reservas automaticamente no sistema.",
    syncing: "Sincronizando...",
    sync: "Sincronizar",
    deleting: "Excluindo...",
    webhookLabel: "WEBHOOK:",
    webhookInfoTooltip:
      "Adicione este Webhook à sua conta Smoobu para receber automaticamente as reservas criadas no seu PMS",
    copyToClipboard: "Copiar para a área de transferência",
    syncedProperties: "Propriedades sincronizadas",
    noAddress: "Sem endereço",
    noSyncedProperties: "Não há propriedades sincronizadas",
  },

  wabaIntegration: {
    activationInProgress: "Ativação em andamento",
    pendingBody:
      "Estamos ativando o WhatsApp da sua empresa. Enquanto a Meta aprova seus modelos (costuma levar até 24&nbsp;h) e verifica seu número, suas mensagens são enviadas com o <strong>WhatsApp da WACheckin</strong> para que você não deixe de se comunicar com seus hóspedes. Mudará para o seu próprio número <strong>automaticamente</strong> assim que estiver pronto — você não precisa fazer nada.",
    phoneStatusHeading: "Estado do número do WhatsApp",
    numberLabel: "Número:",
    virtualNumberNote:
      "Este é um <strong>número virtual fornecido pela Meta</strong>. Não recebe chamadas nem SMS normais, apenas mensagens do WhatsApp pela API.",
    statusLabel: "Estado:",
    templatesStatusHeading: "Estado dos modelos",
    canSend:
      "Seu número está <strong>conectado e verificado</strong> e você tem pelo menos um modelo aprovado. Você já pode enviar mensagens.",
    cannotSendYet:
      "Você <strong>ainda não pode enviar mensagens</strong>. Aguarde a Meta aprovar o número de telefone e os modelos.",
    virtualPendingNote:
      "Tenha em mente que, se o seu negócio na Meta não estiver verificado, os números virtuais podem ficar no estado <strong>pendente</strong> e não permitir o envio.",
    statusConnectedVerified: "Conectado e verificado",
    statusConnectedPending: "Conectado, pendente de verificação",
    statusPendingApproval: "Pendente de aprovação",
    statusDisconnected: "Desconectado",
    statusUnknown: "Desconhecido",
  },
};
